

export function parseDollarAmount(str: string | undefined): string | undefined {
  if (str) {
    return str.trim().replace(/^\$\s*/, '')
  }
}
